<div class="header">
    <div *ngIf="user$ | async as _user"
         class="header-buttons nav-custom__content-right container-fluid px-0 navbar-top navbar-expand navbar-dashboard radiusz-0">
  
         <div class="sp-header__topbar d-flex align-items-center flex-wrap">
            <div class="header-title">
                <h3 class="title prt-mep header-title__text">Bienvenido {{_user.firstname}}</h3>
            </div>

            <div style="    margin-top: -1%;" class="sp-header__topbar d-flex align-items-center flex-wrap">
                  <!--begin: Menu -->
                <div class="sp-header__topbar-item d-md-none" data-toggle="tooltip" data-placement="left" title="Abrir Menú" >
                    <button aria-label="Menú" (click)="openMenu()" class="sp-header__topbar-wrapper sp-header-mobile__toolbar-toggler sp-header-mobile__toolbar-toggler--left" id="sp_aside_mobile_toggler">
                        <span class="sp-header__topbar-icon p-lg-3 p-md-3 p-sm-1">
                            <i class="fa-solid fa-bars mx-1"></i>
                            <span class="text">Menú</span>
                        </span>
                    </button>                
                </div>
            <!--end: Menu -->
            
                <div  class="sp-header__topbar-item" data-toggle="tooltip" data-placement="left" title="Inicio" >
                    <a aria-label="Ir al inicio" class="sp-header__topbar-wrapper" routerLink="/dashboard">
                        <span class="sp-header__topbar-icon p-lg-3 p-md-3 p-sm-1">
                            <i class="fa-solid fa-house"></i>  
                            <span class="text">Inicio</span>
                        </span>
                    </a>
                </div>

                <div class="sp-header__topbar-item dropdown" data-toggle="tooltip" data-placement="left"
                title="Tareas">
                <span class="dot">
                  <span 
                        [style.position]="'absolute'"
                        [style.margin-top.%]="4"
                        [style.margin-left.%]="14"
                        [style.font-size]="getFontSize(chores)"
                        style="font-weight:bold;">
                    {{ chores }}
                  </span>
                </span>
                <button aria-label="Notificaciones" class="sp-header__topbar-wrapper"  data-offset="30px,0px"
                    aria-expanded="false" routerLink="/pageTabPanel" (click)="gettask()">
                    <span class="sp-header__topbar-icon p-lg-3 p-md-3 p-sm-1">
                        <i class="fa-solid fa-tasks">  </i>
                        <span class="text">Tareas</span>
                    </span>
                </button>

                
                <!-- <app-notifications></app-notifications> -->
            </div>

               
                <!--begin: Notifications -->
                <div class="sp-header__topbar-item dropdown" title="Procesos">
                    <button 
                      aria-label="Procesos" 
                      class="sp-header__topbar-wrapper" 
                      type="button"
                      data-bs-toggle="dropdown"
                      data-bs-offset="30,0"
                      aria-expanded="false"
                     
                    >
                      <span class="sp-header__topbar-icon">
                        <i class="fa-solid fa-cogs"></i>
                        <span class="text">Procesos</span>
                      </span>
                    </button>
                  
                    <div class="dropdown-menu dropdown-menu-end py-0" style="width: 346px !important; max-height: 500px; overflow-y: auto;">
                      <app-notifications></app-notifications>
                    </div>
                  </div>
                  

                
             
                <div class="sp-header__topbar-item sp-header__topbar-item--user">

                    <app-settings></app-settings>

                </div>
                <!--end: User Bar -->
                <!--begin: Quick Actions -->
                <div class="sp-header__topbar-item" data-toggle="tooltip" data-placement="left" title="Tus Aplicaciones">

                    <button aria-label="Notificaciones" class="sp-header__topbar-wrapper"  data-offset="30px,0px"
                    aria-expanded="false" routerLink="/pageTabPanel" (click)="getDataImperium()">
                    <span class="sp-header__topbar-icon p-lg-3 p-md-3 p-sm-1">
                        <i class="fa-solid fa-object-group ">  </i>
                        <span class="text">Imperium</span>
                    </span>
                </button>
                </div>


                <div class="sp-header__topbar-item" title="Más">
                    <button class="sp-header__topbar-wrapper" (click)="OpenMas()">
                      <span class="sp-header__topbar-icon">
                        <i class="fa-solid fa-plus-circle"></i>
                        <span class="text">Más</span>
                      </span>
                    </button>
                  </div>

                <div class="sp-header__topbar-item" data-toggle="tooltip" data-placement="left" title="Favoritos" (click)="OpenFav()">
                    <button style="cursor: pointer;"  aria-label="Má" class="sp-header__topbar-wrapper"  id="sp_offcanvas_toolbar_quick_actions_toggler_btn">
                        <span class="sp-header__topbar-icon p-lg-3 p-md-3 p-sm-1">
                            <i style="cursor: pointer;"  class="fa-solid fa-star"></i>
                            <span class="text">Favoritos</span>
                        </span>
                    </button>
                </div>

                <div class="sp-header__topbar-item" data-toggle="tooltip" data-placement="left" title="Tus Aplicaciones" (click)="OpenRec()">
                    <button style="cursor: pointer;"  aria-label="Má" class="sp-header__topbar-wrapper"  id="sp_offcanvas_toolbar_quick_actions_toggler_btn">
                        <span class="sp-header__topbar-icon p-lg-3 p-md-3 p-sm-1">
                            <i style="cursor: pointer;"  class="fa-solid fa-bolt"></i>
                            <span class="text">Recientes</span>
                        </span>
                    </button>
                </div>
                
                <!--end: Quick Actions -->
                <!--begin: LogOut -->
                <div class="sp-header__topbar-item" data-toggle="tooltip" data-placement="left" title="Cerrar Sesión">
                    <button aria-label="Salir" class="sp-header__topbar-wrapper" (click)="salir()">
                        <span class="sp-header__topbar-icon p-lg-3  p-md-3 p-sm-1">
                            <i class="fa-solid fa-arrow-right-from-bracket"></i>
                            <span class="text">Salir</span>
                        </span>
                    </button>
                </div>
                <!--end: LogOut -->
              
                <!-- begin::Offcanvas Toolbar Quick Actions -->
                <div class="overlay" *ngIf="isSidebarCollapsedFavorito" (click)="handleOutsideClickFav()">
                    <div class="sp-offcanvas-panel sp-offcanvas-panel--on" (click)="$event.stopPropagation()">
                      <div class="sp-offcanvas-panel__head" (click)="closeFav()">
                        <h3 class="sp-offcanvas-panel__title">Mis favoritos</h3>
                        <button class="sp-offcanvas-panel__close">
                          <i class="fa-solid fa-xmark"></i>
                        </button>
                      </div>
                      <hr class="solid m-0">
                      <app-favorites (close)="closeFav()"></app-favorites>
                    </div>
                  </div>
                  

                  <div class="overlay" *ngIf="isSidebarCollapsedRecent" (click)="handleOutsideClickRecent()">
                    <div class="sp-offcanvas-panel sp-offcanvas-panel--on" (click)="$event.stopPropagation()">
                      <div class="sp-offcanvas-panel__head" (click)="close()">
                        <h3 class="sp-offcanvas-panel__title">Programas recientes</h3>
                        <button class="sp-offcanvas-panel__close">
                          <i class="fa-solid fa-xmark"></i>
                        </button>
                      </div>
                      <hr class="solid m-0">
                      <app-recent (close)="close()"></app-recent>
                    </div>
                  </div>
                  

           <!-- Contenedor envolvente -->
<div class="overlay" *ngIf="isSidebarCollapsed" (click)="handleOutsideClick($event)">
    <!-- Panel lateral -->
    <div id="sp_offcanvas_toolbar_quick_actionsM" class="sp-offcanvas-panel sp-offcanvas-panel--on">
      <div class="sp-offcanvas-panel__head" sp-hidden-height="88" (click)="closemas()">
        <h3 class="sp-offcanvas-panel__title">Más accesos</h3>
        <button class="sp-offcanvas-panel__close" id="sp_offcanvas_toolbar_quick_actions_close" focus>
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <hr class="solid m-0" />
      <app-moreaccess (close)="closemas()"></app-moreaccess>
    </div>
  </div>

                <div *ngIf="isSidebarCollapsedtemas" id="sp_offcanvas_toolbar_quick_actionsT" class="sp-offcanvas-panel sp-offcanvas-panel--on">
                    <div class="sp-offcanvas-panel__head" sp-hidden-height="88" (click)="closetemas()" >
                        <h3 class="sp-offcanvas-panel__title">
                            Seven Analytics
                        </h3>
                        <button class="sp-offcanvas-panel__close" id="sp_offcanvas_toolbar_quick_actions_close" focus>
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                    <hr class="solid m-0">
                    <app-boardcomponent (close)="closetemas()"></app-boardcomponent>
                </div>
            </div>
        </div>
    </div>
    <div class="z-3 position-absolute bottom-0 end-0 px-3 mt-auto">
        <ins class="px-2 text-muted font-small" ></ins>
        <ins class="px-2 text-muted font-small"></ins>
    </div>
</div>
